import { render, staticRenderFns } from "./custConvertInstallListSpain.vue?vue&type=template&id=5c2a2257&scoped=true&"
import script from "./custConvertInstallListSpain.vue?vue&type=script&lang=js&"
export * from "./custConvertInstallListSpain.vue?vue&type=script&lang=js&"
import style0 from "./custConvertInstallListSpain.vue?vue&type=style&index=0&id=5c2a2257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a2257",
  null
  
)

export default component.exports